import { render } from "./LocalizationEditorField.vue?vue&type=template&id=4d46132c"
import script from "./LocalizationEditorField.vue?vue&type=script&lang=js"
export * from "./LocalizationEditorField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__